import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingSkeleton = props => {
  return /*#__PURE__*/_jsx(AISkeleton, Object.assign({
    shape: "pill"
  }, props, {
    height: 60
  }));
};
export default LoadingSkeleton;